// extracted by mini-css-extract-plugin
export var active = "_f9-7";
export var container = "_f9-0";
export var evenWidth = "_f9-4";
export var large = "_f9-5";
export var outlet = "_f9-8";
export var slide = "_f9-2";
export var small = "_f9-6";
export var tab = "_f9-3";
export var tabs = "_f9-1";